import { useCallback } from "react";
import { routePrefetchers, PrefetchKey } from "@/lib/routePrefetchers";

/**
 * Returns hover/focus handlers that prefetch the route's lazy chunk.
 * Use on nav links to make subsequent navigation instant.
 */
export const usePrefetch = (key: PrefetchKey | undefined) => {
  const trigger = useCallback(() => {
    if (!key) return;
    const fn = routePrefetchers[key];
    if (fn) fn();
  }, [key]);

  return {
    onMouseEnter: trigger,
    onFocus: trigger,
    onTouchStart: trigger,
  };
};
